
export const langData =
{
    "en": {
        "nav": {
            "welcome": "Welcome",
            "about": "About",
            "news": "News",
            "agencies": "Our Agencies",
            "faq": "FAQ",
            "contact": "Contact-us",
        },
        "titles":{
            "nos_partenaires": "Our Partners",
            "nos_services": "Our Services",
            "nos_offres": "Our Offers",
            "questions_frequemment_posees": "FAQ",
            "contact_info": "Contact Info",
            "nos_reseaux_sociaux": "Our social networks",
        },
        "buttons":{
            "suivre_votre_colis": "Track Your Package",
            "se_connecter": "Login",
            "commencez_maintenant": "Start Now",
            "commencez_suivi": "Start Tracking",
            "contacter_centre_appels": "Contact the call center",
        },
        "others":{
            "autre_question": "Any other questions? Talk to us",
            "definition": "NW Express is a solution for managing daily transport and delivery logistics operations.",
            "nous_trouver": "You can find us on",
            "adresse": "62 A, Lotissement des Jeunes Aveugles, Draria, Alger, Algérie",
            "created_by": "Created by",
            "all_rights_reserved": "All rights reserved",
        },
    },
    "fr": {
        "nav": {
            "welcome": "Accueil",
            "about": "A Propos",
            "news": "Actualités",
            "agencies": "Nos Agences",
            "faq": "FAQ",
            "contact": "Contactez-nous",
        },
        "titles":{
            "nos_partenaires": "Nos Partenaires",
            "nos_services": "Nos Services",
            "nos_offres": "Nos Offres",
            "questions_frequemment_posees": "Questions Fréquemment Posées",
            "contact_info": "Coordonnées",
            "nos_reseaux_sociaux": "Nos réseaux sociaux",
        },
        "buttons":{
            "suivre_votre_colis": "Suivre Votre Colis",
            "se_connecter": "Se Connecter",
            "commencez_maintenant": "Commencez Maintenant",
            "commencez_suivi": "Commencez le Suivi",
            "contacter_centre_appels": "Contactez le centre d'appels",
        },
        "others":{
            "autre_question": "D'autre question ? Parlez-nous",
            "definition": "NW Express est une solution pour la gestion des opérations logistiques quotidiennes de transport et de livraison.",
            "nous_trouver": "Vous pouvez nous trouver sur",
            "adresse": "62 A, Lotissement des Jeunes Aveugles, Draria, Alger, Algérie",
            "created_by": "Créé par",
            "all_rights_reserved": "Tous droits réservés",
        },
    },
    "ar": {
        "nav": {
            "welcome": "الرئيسية",
            "about": "من نحن",
            "news": "أخبار",
            "agencies": "وكالاتنا",
            "faq": "الأسئلة الشائعة",
            "contact": "اتصل بنا",
        },
        "titles":{
            "nos_partenaires": "شركاؤنا",
            "nos_services": "خدماتنا",
            "nos_offres": "عروضنا",
            "questions_frequemment_posees": "الأسئلة الشائعة",
            "contact_info": "معلومات الاتصال",
            "nos_reseaux_sociaux": "شبكاتنا الاجتماعية",
        },
        "buttons":{
            "suivre_votre_colis": "تتبع الطرد الخاص بك",
            "se_connecter": "تسجيل الدخول",
            "commencez_maintenant": "ابدأ الآن",
            "commencez_suivi": "بدء التتبع",
            "contacter_centre_appels": "اتصل بمركز الاتصال",
        },
        "others":{
            "autre_question": "هل لديك أي أسئلة أخرى؟ تواصل معنا",
            "definition": "NW Express هو الحل الأمثل لإدارة عمليات النقل والتوصيل اللوجستية اليومية.",
            "nous_trouver": "يمكنك العثور علينا على",
            "adresse": "62 A, Lotissement des Jeunes Aveugles, Draria, Alger, Algérie",
            "created_by": "تم إنشاؤه بواسطة",
            "all_rights_reserved": "جميع الحقوق محفوظة",
        },
    },
}
